<template>
	<div ref="stackedColumns3dChart" style="width: 100%; background-color: #FFFFFF;" :style="{height: chartHeight+'px'}"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

export default {
	name: 'stacked-columns-3d',
	props: {
		chartData: Array,
		chartInfo: Object,
		chartHeight: Number,
		showTotal: Boolean,
	},

	data() {
		return {
			chart: null,
		}
	},

	mounted() {
		this.initialize()
	},

	methods: {
		initialize() {
			if (this.chart) {
				this.chart.dispose()
			}

			if (!this.chartData || this.chartData.length === 0) return

			let chart = am4core.create(this.$refs.stackedColumns3dChart, am4charts.XYChart)
			chart.data = this.chartData
			chart.fontFamily = "'Roboto', sans-serif"
			chart.fontSize = 12
			chart.colors.list = [
				am4core.color('#3d52b0'),
				am4core.color('#0095ef'),
			]

			// Category axis (X) with rotated labels
			let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
			categoryAxis.dataFields.category = 'name'
			categoryAxis.renderer.grid.template.location = 0
			categoryAxis.renderer.labels.template.rotation = 270
			categoryAxis.renderer.labels.template.horizontalCenter = 'right'
			categoryAxis.renderer.labels.template.verticalCenter = 'middle'
			categoryAxis.renderer.minGridDistance = 10

			// Value axis (Y)
			let valueAxis = chart.yAxes.push(new am4charts.ValueAxis())
			valueAxis.title.text = 'Quantità'
			valueAxis.renderer.labels.template.adapter.add('text', (text) => {
				if (text) return text + ' pz'
				return text
			})

			// Series 1: n_1 (period A) — v3 had valueField 'n_1' with title chartInfo.n
			this.createSeries(chart, 'n_1', this.chartInfo.n)
			// Series 2: n (period B) — v3 had valueField 'n' with title chartInfo.n_1
			this.createSeries(chart, 'n', this.chartInfo.n_1)

			// Cursor
			chart.cursor = new am4charts.XYCursor()
			chart.cursor.behavior = 'zoomX'

			// Scrollbar X
			chart.scrollbarX = new am4core.Scrollbar()
			chart.scrollbarX.marginBottom = 20

			// Scrollbar Y
			chart.scrollbarY = new am4core.Scrollbar()

			// Legend
			chart.legend = new am4charts.Legend()
			chart.legend.contentAlign = 'center'

			// Export menu
			chart.exporting.menu = new am4core.ExportMenu()
			chart.exporting.menu.container = document.getElementById('exportbutton')
			chart.exporting.menu.items = [{
				label: '...',
				menu: [
					{ type: 'png', label: 'PNG' },
					{ type: 'jpg', label: 'JPG' },
					{ type: 'csv', label: 'CSV' },
					{ type: 'xlsx', label: 'XLSX' },
					{ type: 'pdf', label: 'PDF' },
				]
			}]

			// Zoom to last 40 items after chart is ready
			chart.events.on('ready', () => {
				this.zoomChart()
			})

			this.chart = chart
		},

		createSeries(chart, valueField, title) {
			let series = chart.series.push(new am4charts.ColumnSeries())
			series.name = title
			series.dataFields.valueY = valueField
			series.dataFields.categoryX = 'name'
			series.stacked = true
			series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]'
			series.columns.template.column.fillOpacity = 0.4
			series.columns.template.column.strokeOpacity = 0.2
			series.columns.template.width = am4core.percent(60)

			// Label bullet (controlled by showTotal)
			let labelBullet = series.bullets.push(new am4charts.LabelBullet())
			labelBullet.label.text = ''
			labelBullet.locationY = 0.5
			labelBullet.label.fontSize = 12

			return series
		},

		zoomChart() {
			if (!this.chart) return
			let categoryAxis = this.chart.xAxes.getIndex(0)
			if (categoryAxis && this.chartData.length > 40) {
				categoryAxis.zoomToIndexes(this.chartData.length - 40, this.chartData.length - 1)
			}
		},
	},

	beforeDestroy() {
		if (this.chart) {
			this.chart.dispose()
		}
	},

	watch: {
		chartData: {
			handler() {
				this.initialize()
			},
			deep: true
		},

		chartInfo: {
			handler() {
				this.initialize()
			},
			deep: true
		},

		showTotal: {
			handler() {
				if (!this.chart) return
				this.chart.series.each((series) => {
					series.bullets.each((bullet) => {
						if (bullet instanceof am4charts.LabelBullet) {
							bullet.label.text = this.showTotal ? '{valueY}' : ''
						}
					})
				})
			}
		}
	},
}
</script>

<style>
</style>
